import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  addNewContactFailure,
  addNewContactSuccess,
} from "../slices/features/newContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* newContactSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.newContact,
      baseUrl,
      id,
      data
    );

    yield put(addNewContactSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(addNewContactFailure({ statusCode, statusText }));
  }
}

export function* watchNewContact() {
  yield takeLatest(RequestTypes.NEW_CONTACT_REQUEST, newContactSaga);
}
